/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React, { createContext, useContext, useEffect, useState } from 'react'
import sseManager from './sseManager' // Your SSEManager utility
import { static_endpoint } from './api_helper'

const SSEContext = createContext()

export const SSEProvider = ({ children }) => {
  const [messages, setMessages] = useState([])

  useEffect(() => {
    // Start the SSE connection
    sseManager.startSSE(`${static_endpoint}globalConnect`)

    // Subscribe to SSE messages
    const handleMessage = (data) => {
      setMessages((prev) => [...prev, data])
    }
    sseManager.subscribe(handleMessage)

    return () => {
      // Unsubscribe and stop SSE on cleanup
      sseManager.unsubscribe(handleMessage)
      sseManager.stopSSE()
    }
  }, [])

  return <SSEContext.Provider value={{ messages }}>{children}</SSEContext.Provider>
}

// Custom hook for accessing SSE data
export const useSSE = () => {
  return useContext(SSEContext)
}
